import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=5fd12896&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"
import style0 from "@/assets/css/scoped/change-password-style.css?vue&type=style&index=0&id=5fd12896&prod&scoped=true&lang=css&external"
import style1 from "@/components/settings/styles/settings-styles.css?vue&type=style&index=1&id=5fd12896&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd12896",
  null
  
)

/* custom blocks */
import block0 from "@/assets/locales/i18n-validation-errors.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2FChangePassword.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/assets/locales/i18n-change-password.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2FChangePassword.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports